var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"transfer-details"},[_c('Heading',{staticClass:"transfer-details__title",attrs:{"level":3}},[_vm._t("title")],2),_c('div',{staticClass:"transfer-details__rows"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }